import { useLocation } from "react-router-dom";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { generateSignature } from "../../redux/apiCalls";
import { deliveryOrderUpload } from "../../redux/apiCalls";
import axios from "axios";

export default function DeliveryOrderUpload() {
    const location = useLocation();
    const productId = location.pathname.split("/")[2];
    const [file, setFile] = useState(null);
    const dispatch = useDispatch();

    const handleClick = async () => {
        if (file == null) {
            return alert("Image is required for creating new product");
        }

        const fileName = new Date().getTime() + file.name;
        const imageresult = await generateSignature();
        const imageFormData = new FormData();

        imageFormData.append("file", file);
        imageFormData.append(
            "publicKey",
            "public_0THMWX6MF/cuVk9EPEFy+e0R0Qk="
        );
        imageFormData.append("signature", imageresult.data.signature);
        imageFormData.append("expire", imageresult.data.expire);
        imageFormData.append("token", imageresult.data.token);
        imageFormData.append(
            "fileName",
            `${fileName} - ${imageresult.data.expire}`
        );
        imageFormData.append("folder", "SSR");

        const imageUploadResult = await axios.post(
            "https://upload.imagekit.io/api/v1/files/upload",
            imageFormData,
            { headers: { "Content-Type": "multipart/form-data" } }
        );

        const updatedProduct = {
            img: imageUploadResult.data.url,
        };
        deliveryOrderUpload(productId, updatedProduct, dispatch);
    };

    return (
        <div className="product">
            <h1 className="addProductTitle">Delivery Order Signed PDF</h1>
            <div className="addProductForm">
                <div className="addProductItem">
                    <label>Signed PDF</label>
                    <input
                        type="file"
                        id="file"
                        onChange={(e) => setFile(e.target.files[0])}
                    />
                </div>
                <button onClick={handleClick} className="addProductButton">
                    Upload
                </button>
            </div>
        </div>
    );
}
